import script from "./SignatureCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureCard.vue?vue&type=script&setup=true&lang=js"

import "./SignatureCard.vue?vue&type=style&index=0&id=4835b77f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4835b77f"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn});
